import { render, staticRenderFns } from "./ShortcutCard.vue?vue&type=template&id=2c7065ae&scoped=true"
import script from "./ShortcutCard.vue?vue&type=script&lang=js"
export * from "./ShortcutCard.vue?vue&type=script&lang=js"
import style0 from "./ShortcutCard.vue?vue&type=style&index=0&id=2c7065ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7065ae",
  null
  
)

export default component.exports